import axios from 'axios';
import { Dispatch } from 'redux';
import { ActionType } from '../Actions/ActionTypes';
import { files } from '../../../../../../config/api';
import FilterDto from '../../../../../../dto/FilterDto';

function fetchFiles(page: number, filter: FilterDto) {
    const params = new URLSearchParams()
    params.append('filter', JSON.stringify(filter))
    return axios.post(files.replace(':page', page.toString()).replace(':sort', '1'), params, undefined)
}

export const actionFetchFiles = (page: number, filter: FilterDto) => {

    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.INDEX_LOAGING })
        fetchFiles(page ,filter).then((res) => {
            dispatch({ type: ActionType.INDEX_DATA, data: res.data.data })
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.INDEX_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.INDEX_ERROR, message: err.response.data.error })
            }
        })
    }
}
